import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const reishauerCustomerGroup = 'reishauer';
export const customerGroup = reishauerCustomerGroup;

export const reishauerNachtschichtReadableId = 'Reishauer_Nachtschicht_Test1';
export const reishauerMeetingraumReadableId = 'Reishauer_Meetingraum_Test1';

const supportEmail = {
	reishauer: 'reishauer@smoothr.de',
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyDx99_I34aUK3cLhF7zTI6Uxcq6FP9qKvA',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup + '-dev',
	...apiEnvironment,
	countryList: ['ch'],
	gaId: '',
	hasRecommendations: true,
	apiUrl: 'https://reishauer.smoothr.de/',
	location: '',
	deactivateDelivery: false,
	enableCashPayment: true,
	allowNavigationToWorldline: false,
	urlQrCode: 'smoothr://',
	reishauerNachtschichtReadableId: reishauerNachtschichtReadableId,
	reishauerMeetingraumReadableId: reishauerMeetingraumReadableId,
};

import 'zone.js';
